import { render, staticRenderFns } from "./editBenefitGroup.vue?vue&type=template&id=984470f2&scoped=true"
import script from "./editBenefitGroup.vue?vue&type=script&lang=js"
export * from "./editBenefitGroup.vue?vue&type=script&lang=js"
import style0 from "./editBenefitGroup.vue?vue&type=style&index=0&id=984470f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "984470f2",
  null
  
)

export default component.exports